// tier-badge-tooltip.js — tap toggling and Escape dismissal for the PDP tier
// tooltips (snippets/tier-badge-tooltip.liquid). Hover and keyboard focus are CSS.
// Added 2026-09-25.
(function () {
  if (window.__tierBadgeTooltip) return;
  window.__tierBadgeTooltip = true;

  function closeAll(except) {
    document.querySelectorAll('.tier-badge.is-open').forEach(function (el) {
      if (el !== except) el.classList.remove('is-open');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.tier-badge__button');
    if (!button) {
      closeAll();
      return;
    }
    var badge = button.closest('.tier-badge');
    badge.classList.remove('is-dismissed');
    closeAll(badge);
    badge.classList.toggle('is-open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tier-badge').forEach(function (el) {
      if (el.classList.contains('is-open') || el.matches(':hover') || el.contains(document.activeElement)) {
        el.classList.add('is-dismissed');
      }
      el.classList.remove('is-open');
    });
  });

  // A dismissed tooltip comes back the next time the badge is hovered or focused.
  ['mouseleave', 'focusout'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var badge = event.target.closest && event.target.closest('.tier-badge');
        if (badge && !badge.contains(event.relatedTarget)) badge.classList.remove('is-dismissed');
      },
      true
    );
  });
})();
